import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { Snowplow2StatsSchemaContentSaveInterface } from '../schema/content-save.interface';
import { StatsContextInterface } from '../../../stats/context.interface';

export class Snowplow2StatsAdapterSchemaContentSave implements StatsAdapterInterface {
  /**
   *
   * @param context
   */
  constructor(protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): Snowplow2StatsSchemaContentSaveInterface {
    return {
      schema: 'iglu:ae.propertyfinder/content_save/jsonschema/1-0-0',
      data: {},
    };
  }
}
